import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Loader from '../../../../common/Loader';
import ModifyNotificationSettings from '../Components/ModifyNotificationSettings';
import MemberList from '../Components/MemberList';
import moment from 'moment';
import OverflowTip from '../../../../common/OverflowTip';
import { getRoleByLabelName } from '../../../../utils/role';
import { useMemo } from 'react';
import CoversationMedia from '../Media';
import SearchBox from '../../../../common/SearchBox';
import MaterialIconToolTip from '../../../../common/MaterialIconToolTip';
import Cookies from 'universal-cookie';
import IconToolTip from '../../../../common/IconToolTip';
import { SearchedMessage } from '../Search/SearchedMessage';
import Tutorial, { chatTutorial, handleTutorialDismiss } from '../../../../common/Tutorial/Tutorial';


const loader = (
    <div className='flex h-screen justify-center items-center'>
        <Loader color='#F48A21' size='30' speed='1' thickness='3' />
    </div>
);

const getAdminUserIds = (users) => {
    let ids = [];
    if (Array.isArray(users)) {
        users.forEach((user) => {
            if (user.isAdmin) ids.push(user.userId);
        });
    }
    return ids;
};

function HelpDetails({ setShowMedia, setIsSearching, isSearching, setSeachQuery, searchTerm, onKeyDownSeach, showSearchedMessages, setShowSearchedMessages }) {
    const { isConversationDetailsLoading } = useSelector((state) => state.loading);
    const { conversationDetails, openedConversationId } = useSelector((state) => state.conversations);

    const { loggedUser } = useSelector((state) => state.auth);
    const helpDetails = conversationDetails[openedConversationId];
    const [helpDetailsInfo, setHelpDetailsInfo] = useState(helpDetails);
    const adminUserIds = getAdminUserIds(helpDetailsInfo?.users);
    const isLoggedUserIsAdmin = adminUserIds.includes(loggedUser?.id);

    const [stepCount, setStepCount] = useState(0);
    useEffect(() => {
        setHelpDetailsInfo(helpDetails);
    }, [helpDetails]);

    let createdByName = helpDetails?.createdBy?.username;

    const membersList = useMemo(() => {
        let members = [];
        if (Array.isArray(helpDetailsInfo?.users)) {
            members = helpDetailsInfo.users.sort((a, b) => a.username.localeCompare(b.username));
        }
        return members;
    }, [helpDetailsInfo?.users]);
    let steps = [
        {

            description: 'Click this search icon.',

            onClick: () => setIsSearching(true),
            style: { top: '1%', left: '9rem' },
            styleSpan: 'h-8 w-8 bg-scogoprimary  transform rotate-45 absolute   left-72 top-2 z-[-3]'
        },

        { description: 'Type here and then press enter', style: { top: '100%', left: '5rem' }, styleSpan: 'h-10 w-14 bg-scogoprimary  transform rotate-45 absolute  right-48 z-[-3]' }


    ];



    function handlePrev() {
        setStepCount(stepCount - 1);
        setSeachQuery('')
        setIsSearching(false)
        setShowSearchedMessages(false)

    }
    function handleNext() {
        setStepCount(stepCount + 1)
    }

    const onSearchClick = () => {
        setIsSearching(true)
        setStepCount(stepCount + 1)
    }

    let helpDetailsBody = (
        <>
            <div className='p-4 grid grid-cols-2 justify-between'>
                <div>
                    <h3 className='text-scogoprimary text-font12 font-medium'>Created On</h3>
                    <h5 className='text-font11 text-scogo99 font-medium break-words pr-4'>{moment(helpDetails?.createdAt).format('DD-MM-YYYY hh:mm A')}</h5>
                </div>
                <div>
                    <h3 className='text-scogoprimary text-font12 font-medium'>Created By</h3>
                    <h5 className='text-font11 text-scogo99 font-medium break-words pr-4'>
                        <OverflowTip someLongText={createdByName} />
                    </h5>
                </div>
            </div>

            {helpDetails?.closedBy && (
                <div className='p-4 grid grid-cols-2 justify-between'>
                    <div>
                        <h3 className='text-scogoprimary text-font12 font-medium'>Closed On</h3>
                        <h5 className='text-font11 text-scogo99 font-medium break-words pr-4'>{moment(helpDetails?.closedBy?.lastSeen).format('DD-MM-YYYY hh:mm A')}</h5>
                    </div>
                    <div>
                        <h3 className='text-scogoprimary text-font12 font-medium'>Closed By</h3>
                        <h5 className='text-font11 text-scogo99 font-medium break-words pr-4'>
                            {helpDetails?.closedBy?.username} ( {getRoleByLabelName(helpDetails?.closedBy?.roleId, helpDetails?.closedBy?.type)} )
                        </h5>
                    </div>
                </div>
            )}

            <ModifyNotificationSettings conversationId={openedConversationId} sendNotificationsFor={helpDetails?.sendNotificationsFor} mainDivClass='p-5 border-t-10' />
            <CoversationMedia mainDivClass='p-5 border-t-10 w-full' setShowMedia={setShowMedia} />
            <MemberList
                conversationId={openedConversationId}
                members={membersList}
                detailsInfo={helpDetailsInfo}
                isLoggedUserIsAdmin={isLoggedUserIsAdmin}
                chatCustomerId={helpDetailsInfo?.info?.customerId}
                numberOfItemToShow={5}
            />
        </>
    );

    return (
        <>
            <div className='chatContainerHeader top-0 sticky flex w-full items-center z-50'>
                {!isSearching ?
                    <div className='flex w-full items-center px-3 justify-between'>
                        <p className='text-scogo15 text-font14 font-medium lg:ml-0 uppercase'>Details</p>
                        <MaterialIconToolTip onClick={onSearchClick} title='Search Chat' materialIconName='search' materialIconClass='text-scogoprimary hover:text-scogoorange cursor-pointer material-icons text-font18' />
                    </div>
                    :
                    <div className='h-full flex items-center w-full justify-between px-2'>
                        <SearchBox searchTerm={searchTerm} onChange={(event) => setSeachQuery(event.target.value.trimStart())} placeholder={'Search Chat Messages'} inputWidthOnFocus='w-96' inputWidth='w-96' showClosedIcon={false}
                            onKeyDown={onKeyDownSeach}
                        />
                        <IconToolTip title="Cancel" onClick={() => {
                            setSeachQuery('')
                            setIsSearching(false)
                            setShowSearchedMessages(false)
                            setStepCount(0)
                        }}>
                            <span className='text-scogoprimary hover:text-scogoorange cursor-pointer material-icons text-font18 mr-4'  >
                                cancel
                            </span>

                        </IconToolTip>
                    </div>
                }
                {/* {showTutorial && <Tutorial handleDismiss={() => handleTutorialDismiss(chatTutorial.key, 'viewed')} tutorialSteps={steps} featureHeading={featureHeading} handlePrev={handlePrev} handleNext={handleNext} stepCount={stepCount} />} */}
            </div>

            <div className={`overflow-y-auto  overflow-x-hidden groupDetailsHeight`}>
                {showSearchedMessages ? <SearchedMessage searchTerm={searchTerm} /> :
                    isConversationDetailsLoading ? loader : helpDetailsBody
                }
            </div>

        </>
    );
}

export default HelpDetails;